import { apiRequest, deleteResource, getResource } from "../api/http";

/** Active genres of a content type, reduced to `{ _id, name }`. */
export function getAllGenres(type) {
  return getResource(`/api/genres/get-active-genres-by-type/${type}`, {
    select: (data) => data.genres.map(({ _id, name }) => ({ _id, name })),
    fallback: [],
  });
}

export function getAllGenreCategories() {
  return getResource("/api/genres/get-all-genres", {
    select: (data) => data.allGenres,
    fallback: [],
  });
}

export function getCategory(genre_id) {
  return getResource(`/api/genres/get-genre/${genre_id}`, {
    select: (data) => data.genre,
    fallback: [],
  });
}

/** Rejects on failure so the form can show the API error. */
export function addGenre(obj) {
  return apiRequest("post", "/api/genres/add-genre", {
    data: obj,
    rethrow: true,
  });
}

export function updateCategory(obj, genre_id) {
  return apiRequest("put", `/api/genres/update-genre/${genre_id}`, {
    data: obj,
  });
}

export function deleteCategory(genre_id) {
  return deleteResource(`/api/genres/delete-genre/${genre_id}`);
}
